<template>
    <a
        v-if="as == 'a'"
        class="text-purple dark:text-brand-light underline hover:opacity-80 transition-opacity"
        target="_blank"
    >
        <slot></slot>
    </a>
    <Link
        v-else
        class="text-purple dark:text-brand-light underline hover:opacity-80 transition-opacity"
    >
        <slot></slot>
    </Link>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
    as: {
        type: String,
        default: null,
    },
});
</script>
